import { useUser } from '%hooks/useUser';
import { useGetUserInfoQuery } from './__generated__/userInfo.generated';

export const useUserInfo = ({ id, uuid }: { id?: string; uuid?: string }) => {
	const currentUser = useUser();

	const { data, loading } = useGetUserInfoQuery({
		variables: { id, uuid },
		fetchPolicy: 'cache-and-network',
	});
	const userInfo = data?.user;
	const temporaryAccessEndDate = userInfo?.temporaryCaregivers?.find(
		(temporaryCaregiver) => temporaryCaregiver.user.id === currentUser.id,
	)?.endDate;

	const isSuperPal = !!userInfo?.superPals?.some((superPal) => superPal.id === currentUser.id);
	const isGuardian =
		userInfo?.guardians?.some((guardian) => guardian.id === currentUser.id) ||
		!!temporaryAccessEndDate;

	return { loading, userInfo, isSuperPal, isGuardian, temporaryAccessEndDate };
};
